module.exports = __webpack_public_path__ + "img/collection-engagementRingsFancy.f75b97d.jpg";